import infoaddSelectReducers from './reducers';
export { default as infoaddSelectOperations } from './operations';
export { default as infoaddSelectTypes } from './types';
export default infoaddSelectReducers;
